import { MCPCHAT_DRAFT_CONVERSATION_KEY } from '../constants/mcpchat.constants';

const conversationCache = new Map();

function getCacheKey(conversationId) {
  return conversationId || MCPCHAT_DRAFT_CONVERSATION_KEY;
}

export function getCachedConversationMessages(conversationId) {
  return conversationCache.get(getCacheKey(conversationId)) || [];
}

export function setCachedConversationMessages(conversationId, messages) {
  conversationCache.set(getCacheKey(conversationId), Array.isArray(messages) ? [...messages] : []);
}

export function appendCachedConversationMessage(conversationId, message) {
  const cacheKey = getCacheKey(conversationId);
  const messages = getCachedConversationMessages(conversationId);
  conversationCache.set(cacheKey, [...messages, message]);
}

export function updateCachedConversationMessage(conversationId, messageId, updater) {
  const cacheKey = getCacheKey(conversationId);
  const messages = getCachedConversationMessages(conversationId);
  const nextMessages = messages.map((message) => {
    if (message.id !== messageId) {
      return message;
    }

    return updater(message);
  });

  conversationCache.set(cacheKey, nextMessages);
}

export function moveCachedConversationMessages(sourceConversationId, targetConversationId) {
  const sourceKey = getCacheKey(sourceConversationId);
  const targetKey = getCacheKey(targetConversationId);

  if (sourceKey === targetKey || !conversationCache.has(sourceKey)) {
    return;
  }

  conversationCache.set(targetKey, getCachedConversationMessages(sourceConversationId));
  conversationCache.delete(sourceKey);
}

export function clearCachedConversationMessages(conversationId) {
  conversationCache.delete(getCacheKey(conversationId));
}

export function clearAllCachedConversationMessages() {
  conversationCache.clear();
}
